import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { CardDetailComponent } from '../features/card/card-detail/card-detail.component';

@Injectable({ providedIn: 'root' })
export class CardDetailUnsavedChangesGuard
  implements CanDeactivate<CardDetailComponent>
{
  canDeactivate(component: CardDetailComponent): boolean {
    return component.canDeactivate();
  }
}
